var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.382 31v-4.265H6.147v-4.117h8.235v-3.97H18.5v3.97h2.28a1.985 1.985 0 1 0 0-3.97H18.5v-4.119h2.28a6.103 6.103 0 1 1 0 12.205H18.5V31h-4.118zm0-16.47H18.5V9.823h8.382V5.706H18.5V1h-4.118v4.706h-1.911a6.47 6.47 0 1 0 0 12.941h1.912V14.53zm0 0h-1.911a2.353 2.353 0 1 1 0-4.706h1.912v4.705z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdp);
export default __webpack_public_path__ + "static/media/USDP.720a796188560aee511d693496afac94.svg";
export { ForwardRef as ReactComponent };